import React from 'react'
import { DcButton, DcInput, PixelFactoryContext } from 'pixel-base'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'

import { addPaymentMethod } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

type AddNewPaymentMethodProps = InferProps<typeof AddNewPaymentMethod.propTypes>

const AddNewPaymentMethod = ({ handleClose }: AddNewPaymentMethodProps) => {
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [data, setData] = React.useState({
    title: '',
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()

    handleAddStatus()
  }

  const handleAddStatus = () => {
    showPageLoader()
    addPaymentMethod(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Added')
        setData({
          title: res.response.data.title,
        })
        handleClose(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <DcInput
            error={
              error.field === 'Title' && error.error !== '' ? error.error : null
            }
            required
            type={'text'}
            name={'Title'}
            placeholder={'Title'}
            value={data.title}
            onChange={(e) => setData({ ...data, title: e.target.value })}
          />
          <DcButton variant="primary" type="submit">
            Save
          </DcButton>
        </FormGroup>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

AddNewPaymentMethod.propTypes = {
  handleClose: PropTypes.func.isRequired,
}

export default AddNewPaymentMethod
